<template>
  <div :style="{backgroundColor: item.bgColor}">
  <!-- <div :style="`background-color: ${item.bgColor}; backgroung-image: url(${item.bgImg[0].url? item.bgImg[0].url : none}); background-size: 100% 100%;`"> -->
    <div :style="{textAlign:'center', color: item.wrapEnTitColor, fontSize: '12px', padding: '20px 0 0 0'}">{{ item.wrapEnTit }}</div>
    <div :style="{textAlign:'center', color: item.wrapTitColor, fontSize: '24px', fontWeight: 'bold',padding: '10px 0'}">{{ item.wrapTit }}</div>
    <div
      v-for="listItem in item.picList" class="imgTextBlock" :key="listItem.title"
      :style="{padding: `${item.paddTop}px ${item.paddLeft}px`, flexDirection: listItem.imgAlign}"
      >
      <img :src="listItem.url" :style="{width: listItem.width, borderRadius: listItem.imgRadius + 'px'}" />
      <div :style="{justifyContent: listItem.conWrapAlign}">
        <div :style="{color: listItem.subTitColor, textAlign: listItem.titleAlign,fontSize: listItem.subTitleSize+'px'}">{{listItem.subTitle}}</div>
        <h6 :style="{textAlign: listItem.titleAlign, color: listItem.titleColor, padding: `${listItem.titPaddTop}px 0`, fontSize: listItem.titleSize+'px'}">{{ listItem.title }}</h6>
        <div class="lineWrap" :style="{textAlign: listItem.titleAlign}"><span :style="{display: listItem.isShowLine? 'inline-block' : 'none', backgroundColor: listItem.lineColor}"></span></div>
        <p :style="{textAlign: listItem.contentAlign, color: listItem.contentColor, fontSize: listItem.contentSize+'px'}">{{ listItem.content }}</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.imgTextBlock{
  display: flex;
  > img {
    width: 30%;
    max-height: 165px;
    overflow: hidden;
  }
  > div {
    width: 70%;
    display: flex;
    padding: 0 10px;
    flex-direction: column;

    > h6 {
      margin: 0;
      line-height: 30px;
    }
    > p {
      margin: 0;
      line-height: 20px;
    }
    .lineWrap{
      > span{
        width: 36px;
        height: 2px;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
}

</style>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    // listWrapObject() {
    //   return {

    //   }
    // }
  },
}
</script>

